import { useEffect, useState } from 'react';
import { NavLink, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from './lib/auth';

export function App() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);

  // Auto-close drawer on route change.
  useEffect(() => { setDrawerOpen(false); }, [loc.pathname]);

  // Lock body scroll while drawer is open (mobile only).
  useEffect(() => {
    if (drawerOpen) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
    return () => { document.body.style.overflow = ''; };
  }, [drawerOpen]);

  return (
    <div className="app">
      <header className="topbar">
        <button
          className="hamburger"
          aria-label="Toggle navigation"
          onClick={() => setDrawerOpen(v => !v)}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>
        <div className="brand">VR-ATG Polling Platform</div>
        <div className="spacer" />
        <div className="user">
          <span className="user-name">{user?.displayName} · </span>
          <span className="pill">{user?.role}</span>
        </div>
        <button className="ghost" onClick={async () => { await logout(); nav('/login'); }}>
          <span className="signout-text">Sign out</span>
          <span className="signout-icon" aria-label="Sign out" title="Sign out">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <polyline points="16 17 21 12 16 7" />
              <line x1="21" y1="12" x2="9" y2="12" />
            </svg>
          </span>
        </button>
      </header>
      <div className="layout">
        <nav className={'sidebar' + (drawerOpen ? ' open' : '')}>
          <NavLink end to="/">Dashboard</NavLink>
          <NavLink to="/sites">Sites &amp; ATGs</NavLink>
          <NavLink to="/inventory">Inventory</NavLink>
          <NavLink to="/reports">Reports</NavLink>
          <NavLink to="/terminal">Live Terminal</NavLink>
          {user?.role === 'admin' && <NavLink to="/admin">Admin</NavLink>}
        </nav>
        <div
          className={'scrim' + (drawerOpen ? ' open' : '')}
          onClick={() => setDrawerOpen(false)}
        />
        <main className="content"><Outlet /></main>
      </div>
    </div>
  );
}
